import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'
import { ExclamationCircle } from '@styled-icons/bootstrap/ExclamationCircle'

import Tooltip from '../../common/tooltip'
import { MemoContext, SELECT_DTC_MEMO } from './context/context'
import { useContext } from 'react'

const ExclamationMark = () => {
  return (
    <div className="pl-6 py-2">
      <ExclamationCircle size="1rem" color="red" />
    </div>
  )
}

const MemosRow = (props) => {
  const [state, dispatch] = useContext(MemoContext)

  return (
    <div>
      <div
        className={`w-full py-2 px-3 border-b border-b-gray text-black ${props.status == 'rejected' ? 'bg-green-400' : 'bg-white'}`}
      >
        <div className="flex flex-row w-full">
          <div className="flex w-3/12 pl-10 items-center table_text">
            <Tooltip message={props.acronym}>
              <div>{props.acronym}</div>
            </Tooltip>
          </div>
          <div className="flex w-3/12 pl-6 items-center table_text">
            <Tooltip message={props.dtc_obj ? props?.dtc_obj?.name : props.dtc}>
              <div>{props.dtc_obj ? props?.dtc_obj?.name : props.dtc}</div>
            </Tooltip>
          </div>
          <div className="w-5/12 pl-6 table_text">
            <Tooltip message={props.short_desc}>
              <div>{props.short_desc}</div>
            </Tooltip>
          </div>
          <div className="flex w-1/12 pl-6 items-center ">
            <div>
              {props.showAction ? (
                <span
                  onClick={() => {
                    props.setSelectedItem(props)
                  }}
                  className={`cursor-pointer underline font-normal ${props.status == 'rejected' ? 'text-white' : 'text-blue-500'}`}
                >
                  Review
                </span>
              ) : (
                <>
                  <span
                    onClick={() => {
                      dispatch({
                        type: SELECT_DTC_MEMO,
                        data: { selected_memo: props, show_memo_popup: true },
                      })
                    }}
                    className="cursor-pointer"
                  >
                    <Edit size="2rem" color="#0189E9" />
                  </span>
                  <span
                    onClick={() => {
                      props.onDelete()
                    }}
                    className="cursor-pointer p-2"
                  >
                    <TrashAlt size="2rem" color="#0189E9" />
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {props.id == props?.selectedItem?.id && (
        <div className="bg-gray-300 text-black">
          <div className="flex flex-row w-full font-medium border-b-gray pt-2">
            <div className="flex w-5/12 pl-6 items-center">
              DTC Description / Memo
            </div>
            <div className="flex w-5/12 pl-2 items-center border-l-gray">
              Crowdsourced Memos
            </div>
            <div className="flex w-2/12 pl-6 items-center border-l-gray">
              <span
                className="cm-positive cursor-pointer"
                onClick={() => {
                  props.memoAction('accept')
                }}
              >
                Accept
              </span>
              <span className="pl-3">&nbsp;</span>
              <span
                className="border-l-gray cm-negative cursor-pointer pl-3"
                onClick={() => {
                  props.memoAction('reject')
                }}
              >
                Reject
              </span>
            </div>
          </div>
          <div className="flex flex-row w-full pb-4">
            <div className="w-5/12 items-center">
              {props?.atMemo?.memo ? (
                <div
                  dangerouslySetInnerHTML={{ __html: props?.atMemo?.memo }}
                  key={`at-memo`}
                  className="pl-6 py-2"
                />
              ) : (
                <ExclamationMark />
              )}
            </div>
            <div className="w-7/12 items-center border-l-gray">
              {props?.memo ? (
                <div
                  dangerouslySetInnerHTML={{ __html: props?.memo }}
                  key={`tracer-memo`}
                  className="pl-2 py-2"
                />
              ) : (
                <ExclamationMark />
              )}
            </div>
          </div>
          <div className="border-b-gray "></div>

          <div className="flex flex-row w-full pb-4">
            <div className="w-5/12 items-center">
              {props?.atMemo?.description ? (
                <div className="font-medium pl-6 py-2">
                  {props?.atMemo?.description}
                </div>
              ) : (
                <ExclamationMark />
              )}
            </div>

            <div className="w-7/12 items-center border-l-gray">
              {props.short_desc ? (
                <div className="font-medium py-2 pl-2 ">{props.short_desc}</div>
              ) : (
                <ExclamationMark />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MemosRow
